import { ArtSickleCellBackgroundWithWoman } from 'assets'
import React from 'react'
import {
  BuildingOffice2Icon,
  UserGroupIcon,
  ChartBarIcon,
  DocumentTextIcon
} from '@heroicons/react/24/outline'

export const OurGoals: React.FC = () => {
  const goals = [
    {
      title: 'Infrastructure',
      text: 'We are committed to creating an infrastructure for adult and pediatric sickle cell disease centers to define, enhance, and promote the adoption of standards of primary and specialized care.',
      Icon: BuildingOffice2Icon
    },
    {
      title: 'Collaboration',
      text: "Work with the American Society of Hematology, the Sickle Cell Disease Association of America, and the CDC's Sickle Cell Data Collection program along with other organizations to collaborate on research, data collection, advocacy and other efforts.",
      Icon: UserGroupIcon
    },
    {
      title: 'Quality Improvement',
      text: 'Work to enable access to the Globin Research Network for Data and Discovery, a multi-site registry to optimize quality improvement and quality assurance through data analytics.',
      Icon: ChartBarIcon
    },
    {
      title: 'Tools and Information',
      text: 'Develop tools and share information with sickle cell disease centers to use in implementing and operating a comprehensive care model within their organization.',
      Icon: DocumentTextIcon
    }
  ]

  return (
    <section className="py-16">
      <div className="container mx-auto px-4 max-w-7xl">
        {/* Header Section */}
        <div className="flex flex-col md:flex-row gap-8 items-center mb-16">
          <div className="w-full md:w-1/3">
            <img
              src={ArtSickleCellBackgroundWithWoman}
              alt="Our Goals Illustration"
              className="w-full h-auto"
            />
          </div>
          <div className="w-full md:w-2/3">
            <h2 className="text-[#3C2416] text-4xl font-bold mb-4">
              Our Goals
            </h2>
            <p className="text-[#142841] text-lg leading-relaxed">
              We are committed to providing support, education, and other
              resources to sickle cell centers across America in order to
              enhance the quality of patient care and improve outcomes for
              patients and the centers alike.
            </p>
          </div>
        </div>

        {/* Goals Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {goals.map((goal, index) => (
            <div
              key={index}
              className="bg-white rounded-lg shadow-md p-6 hover:shadow-lg transition-shadow duration-200"
            >
              <div className="mb-4">
                <goal.Icon className="w-12 h-12 text-[#A6410A]" />
              </div>
              <h3 className="text-[#A6410A] text-xl font-semibold mb-3">
                {goal.title}
              </h3>
              <p className="text-[#142841] leading-relaxed">{goal.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
